import { Back } from '../../../components/buttons/backButton/Back'
import MainButton from "../../../components/buttons/mainButton/MainButton"
import Field from "../../../components/textField/Field"
import { translations } from "../../../configs/translations"
import { useStore } from "../../../store/store"

interface PasswordRecoveryWindowEmailProps {
    email: string;
    errors: any;
    registerField: any;
    onSubmit: () => void;
}

export const PasswordRecoveryWindowEmail = ({
    email,
    errors,
    registerField,
    onSubmit
}: PasswordRecoveryWindowEmailProps) => {
    const language = useStore(state => state.language);
    const t = translations[language];


    return (
        <div className="container">
            <div className="window window-recovery">
                <div className="window-recovery-back-button">
                    <Back onClick={() => window.history.back()} text={""} />
                </div>
                <h1 className='title'>{t.password_recovery} 1/3</h1>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit();
                }} className='fields'>
                    <Field 
                        value={email}
                        label={t.username_email} 
                        placeholder={t.enter_username_email}
                        error={errors.email?.message}
                        type="text"
                        {...registerField('email')}
                    />

                    <MainButton text={t.continue} type="submit" />
                </form>
            </div>
        </div>
    );
}